import { Button } from "@Utilities/Button";
import "./_Accessories.scss";

import { Cart, ICartCallback, ICartProduct } from "@Utilities/Cart";
import { Tenant } from "@Utilities/Tenant";

export class Accessories
{
	private Cart: Cart;
	private Container: HTMLElement;
	public CartCallback: ICartCallback;

	constructor()
	{
		this.Container = document.querySelector(".relAcc") as HTMLElement;

		if (this.Container !== null)
		{
			this.Cart = new Cart();
			this.ConfigureAddToCart();
			this.ConfigureSizePrice();
		}
	}

	private AddToCartHandler = (e: Event): void =>
	{
		e.preventDefault();

		const target = e.currentTarget as HTMLElement;

		const form = target.closest(".relAcc__item");
		const select = form.querySelector("select") as HTMLSelectElement;

		const productID = target.getAttribute("data-productid");
		const productSizeID = select.value;
		const cartItemOriginID = target.getAttribute("data-origin-id");
		const quantity = 1;

		const product: ICartProduct = {
			ProductID: productID,
			ProductSizeID: productSizeID,
			Quantity: quantity,
			CartItemOriginID: cartItemOriginID
		};

		Button.StartLoading(target);
		this.Cart.AddProduct(product, this.CartCallback);
	};

	private ConfigureAddToCart = (): void =>
	{
		const buttons = this.Container.querySelectorAll(".add-rec") as NodeListOf<HTMLElement>;

		buttons.forEach((button) =>
		{
			Button.EnableLoading(button);
			button.addEventListener("click", this.AddToCartHandler);
		});
	};

	private ConfigureSizePrice = (): void =>
	{
		const sizeSelector = this.Container.querySelectorAll("select");

		sizeSelector.forEach((select) =>
		{
			select.addEventListener("change", this.UpdateSizePrice);
		});
	};

	private UpdateSizePrice = (e): void =>
	{
		const el = e.currentTarget as HTMLSelectElement;
		const price = el.options[el.selectedIndex].getAttribute("data-price");
		const item = el.closest(".relAcc__item");
		const priceEl = item.querySelector(".price");
		priceEl.textContent = price;
	};
}